import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

/**
 * @param {string} stockCode
 */
function useAbout(stockCode, options = {}) {
  const { cb, key } = fetch(stockCode);
  const { data, isSuccess, refetch } = useQuery(key, cb, {
    enabled: !!stockCode,
    // this data is not changed frequently, so we can cache it for 24 hours
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
    ...options,
  });

  return { data, isSuccess, refetch };
}

export default {
  useAbout,
};
